import React, { useEffect, useState } from 'react';
import { MaskingHandlerResult } from '../../infrastructure/types/common/common-types';

interface MaskOptions<InputType> {
  maskHandler: (value: InputType) => MaskingHandlerResult<InputType>;
  onAccept: (maskedValue: InputType, unmaskedValue: InputType) => void;
  defaultValue?: InputType;
}

interface MaskData<InputType> {
  value: InputType;
  unmaskedValue: InputType;
  onChangeMaskedValue: (value: InputType) => void;
}

function useMask<InputType>({
  defaultValue,
  maskHandler,
  onAccept,
}: MaskOptions<InputType>): MaskData<InputType> {
  const [value, setValue] = useState<InputType>('' as InputType);
  const [unmaskedValue, setUnmaskedValue] = useState<InputType>('' as InputType);

  useEffect(() => {
    if (defaultValue && !value) {
      handleChange(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (currentValue: InputType) => {
    const { updatedValue, updatedUnmaskedValue } = maskHandler(currentValue);

    setValue(updatedValue);
    setUnmaskedValue(updatedUnmaskedValue);
    onAccept && onAccept(updatedValue, updatedUnmaskedValue);
  };

  return {
    value: value,
    unmaskedValue: unmaskedValue,
    onChangeMaskedValue: handleChange,
  };
}

export { useMask };
